import '@d3fc/d3fc-element';
import { SymbolTileDataTimeSeriesItem } from 'widgets/symbolTile/components/symbolTileData';
import { AnySelection, seriesSvgArea } from '@d3fc/d3fc-series';

export const getPriceAreaSeries = (gradientId: string, yStart: number) =>
    seriesSvgArea()
        .crossValue((x: SymbolTileDataTimeSeriesItem) => x.time)
        .baseValue(() => yStart)
        .mainValue((x: SymbolTileDataTimeSeriesItem) => x.price)
        .decorate((selection: AnySelection) => {
            selection.classed('price-area', true);
            selection.attr('fill', `url(#${gradientId})`);
        });
